var defaultState = {
    payLater: false,
    showMarketingSettings: false,
    showPrivacySettings: false
};
export default defaultState;
